import styled from '@emotion/styled'
import { scaleLinear } from 'd3-scale'
import { Flex } from '../atoms/Basics'

const Container = styled.div`
  margin: 2rem 0;
`

const Title = styled.div`
  font-family: ${(props) => props.theme.fonts.title};
  font-weight: 700;
  text-transform: uppercase;
  color: ${(props) =>
    props.type === 'strengths'
      ? props.theme.colors.blue
      : props.type === 'needs'
      ? props.theme.colors.green
      : props.theme.colors.orange};
  letter-spacing: 1.8px;
`
const Line = styled.div`
  width: ${(props) => props.width}%;
  border-top: 1px solid
    ${(props) =>
      props.type === 'strengths'
        ? `${props.theme.colors.blue}`
        : props.type === 'needs'
        ? props.theme.colors.green
        : `${props.theme.colors.orange}`};
  border-bottom: 1px solid
    ${(props) =>
      props.type === 'strengths'
        ? `${props.theme.colors.blue}`
        : props.type === 'needs'
        ? props.theme.colors.green
        : `${props.theme.colors.orange}`};
`
const Circle = styled.div`
  background-color: ${(props) =>
    props.type === 'strengths'
      ? `${props.theme.colors.blue}`
      : props.type === 'needs'
      ? props.theme.colors.green
      : `${props.theme.colors.orange}`};
  border-radius: 50%;
  width: 0.5rem;
  height: 0.5rem;
  //to center on end of line:
  margin-left: -0.25rem;
`
const Label = styled.p`
  font-size: ${(props) => props.theme.fontSizes[0]};
  font-weight: 600;
  color: ${(props) =>
    props.type === 'strengths'
      ? `${props.theme.colors.blue}`
      : props.type === 'needs'
      ? `${props.theme.colors.green}`
      : `${props.theme.colors.orange}`};
`
const Percent = styled.p`
  font-size: ${(props) => props.theme.fontSizes[1]};
  font-weight: 700;
  color: ${(props) =>
    props.type === 'strengths'
      ? `${props.theme.colors.blue}`
      : props.type === 'needs'
      ? props.theme.colors.green
      : `${props.theme.colors.orange}`};
  padding-left: 0.4rem;
`
const StyledFlex = styled(Flex)`
  align-items: center;
  line-height: 1;
`

const Row = styled.div`
  margin-top: 0.5rem;
`
const Lines = ({ data, type, scale }) => {
  const x = scaleLinear([0, scale * 100], [0, 80])
  const topFive = Object.entries(data)
    ?.sort((a, b) => b[1] - a[1])
    .slice(0, 5)

  return (
    <Container>
      <Title type={type}>Top {type}</Title>
      {topFive?.map((item) => {
        return (
          <Row key={item[0]}>
            <Label type={type}>{item[0]}</Label>
            <StyledFlex alignItems="center">
              <Line width={x(item[1] * 100) || 0} type={type} />
              <Circle type={type} />
              <Percent type={type}>{(item[1] * 100).toFixed(1)}%</Percent>
            </StyledFlex>
          </Row>
        )
      })}
    </Container>
  )
}

export default Lines
